import React, { Component } from 'react'
import { connect } from 'react-redux'
class AccessResult extends Component {
  clearSearch () {
    this.props.dispatch({
      type: 'SET_SEARCH',
      payload: {
        query: '',
        total: 0,
        results: false
      }
    })
    return true
  }
  render () {
    return (
      <a key={'result' + this.props.result.accessId} onClick={e => this.clearSearch()} href={'#/access/' + this.props.result.accessId} className={'list-group-item ' + (this.props.active ? 'active list-group-item-active' : '')} >
        <div className='search-icon-wrapper'>
          <i className={'fa fa-fw fa-home'} />
        </div>
        <div className='flow-search-result-wrapper'>
          <h4 className='list-group-item-heading'>{this.props.result.streetName + ' ' + (this.props.result.streetNumber || '') + ' ' + (this.props.result.streetLittera || '')} <small>{this.props.result.mduApartmentNumber || '' + ' ' + this.props.result.mduDistinguisher || ''}</small></h4>
          <p className='list-group-item-text'>{this.props.result.postalCode + ' ' + (this.props.result.city || '')} <span className='label label-dark' style={{
            'position': 'absolute',
            'fontSize': '11px',
            'marginLeft': '3px',
            'marginTop': '1px'
          }}>{this.props.result.accessId}</span> </p>
        </div>
      </a>
    )
  }
}
// eslint-disable-next-line
AccessResult = connect(state => state.siteReducer)(AccessResult)
export default AccessResult



// WEBPACK FOOTER //
// ./src/projects/access-gui/components/core/search/AccessResult.js